import React, { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet';

export default function Header() {
    const [head, setHead] = useState('');
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname
        switch (path) {
            case '/':
                setHead({ title: 'Saveliy Saunin', description: "Check out Saveliy's Projects!" });
                break;
            case '/about':
                setHead({ title: 'About - Saveliy Saunin', description: "Learn about Saveliy!" });
                break;
            case '/login':
                setHead({ title: 'Login - Saveliy Saunin', description: "Log in to Saveliy's website." });
                break;
            default:
                setHead({ title: 'Page Not Found - 404', description: "This page doesn't exist" });
        }
    }, [location]);
    return (
        <header>
            <Helmet>
                <title>{head.title}</title>
                <meta name="description" content={head.description} />
                <meta property="og:description" content={head.description} />
                <meta property="og:title" content={head.title} />
            </Helmet>
            {location.pathname !== '/' && <div style={{
                display: 'grid',
                gridTemplateColumns: 'auto auto',
                alignItems: 'center',
                gap: 10,
                padding: "0 20px"
            }}>
                <img style={{ height: 50 }} alt="Logo Saveliy Saunin" src="/LogoTransparent.png" />
                <div className="logoText">Saveliy Saunin</div>
            </div>}
            <nav>
                <ul style={{ display: 'flex', flexDirection: 'row' }}>
                    <li>
                        <Link className={location.pathname === '/' ? 'selected' : ''} to="/">HOME</Link>
                    </li>
                    <li>
                        <Link className={location.pathname === '/about' ? 'selected' : ''} to="/about">ABOUT</Link>
                    </li>
                </ul>
            </nav>
        </header>
    )
}